export const SET_COMPATIBLE_BROWSER = "SET_COMPATIBLE_BROWSER";
export const START_CONNECTING_DEVICE = "CONNECTING_DEVICE";
export const FINISH_CONNECTING_DEVICE = "FINISH_CONNECTING_DEVICE";
export const SET_DEVICE = "SET_DEVICE";
export const CLEAR_DEVICE = "CLEAR_DEVICE";
export const SET_PAYLOAD_DEFINITIONS = "SET_PAYLOAD_DEFINITIONS";
export const SET_ACTIVE_PAYLOAD = "SET_ACTIVE_PAYLOAD";
export const START_ACTIVE_PAYLOAD_LOADING = "START_ACTIVE_PAYLOAD_LOADING";
export const FINISH_ACTIVE_PAYLOAD_LOADING = "FINISH_ACTIVE_PAYLOAD_LOADING";
export const SET_PAYLOAD_DOWNLOAD_PROGRESS = "SET_PAYLOAD_DOWNLOAD_PROGRESS";
export const START_RUN_EXPLOIT = "START_RUN_EXPLOIT";
export const FINISH_RUN_EXPLOIT = "FINISH_RUN_EXPLOIT";
export const ADD_LOG_MESSAGE = "ADD_LOG_MESSAGE";
export const SET_WRITE_PAYLOAD_PROGRESS = "SET_WRITE_PAYLOAD_PROGRESS";
export const CLEAR_LOG = "CLEAR_LOG";
